export enum ActionConstants {
  FETCH_PLATFORM_CONFIG_SUCCESS = 'FETCH_PLATFORM_CONFIG_SUCCESS',
  FETCH_PLATFORM_CONFIG_ERROR = 'FETCH_PLATFORM_CONFIG_ERROR',
  FETCH_PLATFORM_CONFIG_REQUEST = 'FETCH_PLATFORM_CONFIG_REQUEST',
}
